<template>
    <div class="toast" v-if="isLoading">
		<i></i>{{ loadingMsg || "加载中，请稍候..."}}
	</div>
</template>

<script>
export default {
  name: "Loading",
  props: ["isLoading", "loadingMsg"]
}
</script>
